import { Button } from "@/components/ui/button";
import { ERP_MODULES, eur, num } from "./erpShared";

export default function ErpDashboard({ flags, facturen = [], inkooporders = [], setTab }) {
  const enabled = ERP_MODULES.filter((m) => m.built && flags[m.key]);
  const openstaand = facturen.filter((f) => f.status === "Verstuurd").reduce((s, f) => s + num(f.totaal), 0);
  const lopendeInkoop = inkooporders.filter((o) => !["Ontvangen", "Geannuleerd"].includes(o.status)).length;
  return (
    <div className="space-y-4" data-testid="erp-dashboard">
      <h2 className="text-lg font-bold text-slate-800">ERP-overzicht</h2>
      {enabled.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center">
          <p className="text-slate-600">Er zijn nog geen modules ingeschakeld.</p>
          <p className="mt-1 text-sm text-slate-400">Ga naar het tabblad <b>Modules</b> om te kiezen wat je wilt gebruiken. Alles staat standaard uit tot jij het aanzet.</p>
          <Button className="mt-3" data-testid="erp-go-modules" onClick={() => setTab("modules")}>Naar Modules</Button>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            <div className="rounded-lg border border-slate-200 bg-white p-3"><div className="text-xs text-slate-500">Actieve modules</div><div className="text-xl font-bold text-slate-800">{enabled.length}</div></div>
            {flags.facturen && <div className="rounded-lg border border-slate-200 bg-white p-3" data-testid="erp-kpi-facturen"><div className="text-xs text-slate-500">Openstaand (facturen)</div><div className="text-xl font-bold text-slate-800">{eur(openstaand)}</div></div>}
            {flags.inkoop && <div className="rounded-lg border border-slate-200 bg-white p-3" data-testid="erp-kpi-inkoop"><div className="text-xs text-slate-500">Lopende inkooporders</div><div className="text-xl font-bold text-slate-800">{lopendeInkoop}</div></div>}
          </div>
          <div className="flex flex-wrap gap-2">
            {enabled.map((m) => { const Icon = m.Icon; return <Button key={m.key} variant="outline" size="sm" data-testid={`erp-quick-${m.key}`} onClick={() => setTab(m.key)}><Icon className="h-4 w-4 mr-1" />{m.label}</Button>; })}
          </div>
        </>
      )}
    </div>
  );
}
